import React, { useState } from 'react';
import { BookOpenIcon, ChartBarIcon, FunnelIcon, InformationCircleIcon } from '@heroicons/react/24/outline';

const GlobalFeedExplainer = ({ onContinue }) => {
  const [dontShowAgain, setDontShowAgain] = useState(false);

  const handleContinue = () => {
    if (dontShowAgain) {
      // Save preference to localStorage
      localStorage.setItem('tom_global_feed_explainer_dismissed', 'true');
    }
    onContinue(dontShowAgain);
  };

  return (
    <div className="flex flex-col items-center justify-center py-8 px-4 sm:px-6 lg:px-8 min-h-[500px] max-w-2xl mx-auto">
      <div className="w-full">
        <div className="flex justify-center mb-6">
          <div className="rounded-full bg-blue-100 p-4">
            <svg className="h-12 w-12 text-blue-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3.055 11H5a2 2 0 012 2v1a2 2 0 002 2 2 2 0 012 2v2.945M8 3.935V5.5A2.5 2.5 0 0010.5 8h.5a2 2 0 012 2 2 2 0 104 0 2 2 0 012-2h1.064M15 20.488V18a2 2 0 012-2h3.064M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
            </svg>
          </div>
        </div>

        <h2 className="text-2xl sm:text-3xl font-bold text-gray-900 text-center mb-2">
          Together On Mission Global Feed
        </h2>
        <p className="text-gray-600 text-center mb-8 text-sm sm:text-base">
          Connect with believers around the world
        </p>

        <div className="space-y-6 mb-8">
          <div className="flex items-start gap-4">
            <div className="flex-shrink-0">
              <div className="rounded-full bg-blue-100 p-3">
                <BookOpenIcon className="h-6 w-6 text-blue-600" />
              </div>
            </div>
            <div className="flex-1">
              <h3 className="text-lg font-semibold text-gray-900 mb-2">Stories</h3>
              <p className="text-gray-600 text-sm sm:text-base">
                See inspiring "God at Work" stories from believers worldwide who have chosen to share their journey publicly.
              </p>
            </div>
          </div>

          <div className="flex items-start gap-4">
            <div className="flex-shrink-0">
              <div className="rounded-full bg-blue-100 p-3">
                <ChartBarIcon className="h-6 w-6 text-blue-600" />
              </div>
            </div>
            <div className="flex-1">
              <h3 className="text-lg font-semibold text-gray-900 mb-2">Activities</h3>
              <p className="text-gray-600 text-sm sm:text-base">
                View activities from the global community including prayers, connections, and discipleship milestones.
              </p>
            </div>
          </div>

          <div className="flex items-start gap-4">
            <div className="flex-shrink-0">
              <div className="rounded-full bg-blue-100 p-3">
                <FunnelIcon className="h-6 w-6 text-blue-600" />
              </div>
            </div>
            <div className="flex-1">
              <h3 className="text-lg font-semibold text-gray-900 mb-2">Filter Options</h3>
              <p className="text-gray-600 text-sm sm:text-base">
                Use the filter menu in the header to view all content, or just stories and announcements.
              </p>
            </div>
          </div>
        </div>

        <div className="bg-blue-50 border-l-4 border-blue-600 p-4 mb-6 rounded-r-lg">
          <div className="flex items-start gap-3">
            <InformationCircleIcon className="h-5 w-5 text-blue-600 flex-shrink-0 mt-0.5" />
            <p className="text-sm text-gray-700">
              This is a global feed showing content from believers who have chosen to share publicly. Your local community activities appear in "My Community".
            </p>
          </div>
        </div>

        <div className="flex items-center justify-center mb-6">
          <label className="flex items-center cursor-pointer">
            <input
              type="checkbox"
              checked={dontShowAgain}
              onChange={(e) => setDontShowAgain(e.target.checked)}
              className="w-5 h-5 text-blue-600 border-gray-300 rounded focus:ring-blue-500"
            />
            <span className="ml-2 text-sm text-gray-700">Don't show this again</span>
          </label>
        </div>

        <button
          onClick={handleContinue}
          className="w-full sm:w-auto px-8 py-3 bg-gradient-to-r from-blue-600 to-green-500 text-white rounded-lg hover:from-blue-700 hover:to-green-600 transition-all duration-200 font-semibold text-base shadow-lg hover:shadow-xl flex items-center justify-center gap-2 mx-auto"
        >
          <span>Explore Global Feed</span>
          <svg className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 7l5 5m0 0l-5 5m5-5H6" />
          </svg>
        </button>
      </div>
    </div>
  );
};

export default GlobalFeedExplainer;
